// extracted by mini-css-extract-plugin
module.exports = {"projectsBlock":"Projects_projectsBlock__2gnSl","worksContainer":"Projects_worksContainer__23gAK","works":"Projects_works__3Emge"};